import { CopyOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react'
import { _Toastr } from 'services/Toastr/Notify/_Toastr.js';

function RiwayatKonselingExpand(record) {

    let nama = record.namapembeli;

     

    nama = nama
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");

    const room = `${nama}-${record.kodeorderkonseling}`;
    const urljitsi = `https://meet.jit.si/rs-ruslan-${room}#config.prejoinPageEnabled=false&config.disableDeepLinking=true`

    if(record.status === "KPK")
    return (
        <p style={{ padding: 10 }}>
            <a
                // href={`https://meet.jit.si/${room}#config.prejoinPageEnabled=false`}
                href={urljitsi}
                target="_blank"
                rel="noopener noreferrer"
            >
                {urljitsi}
            </a>

            <Button
                size="small"
                icon={<CopyOutlined />}
                style={{ marginLeft: 10 }}
                onClick={() => {
                    navigator.clipboard.writeText(urljitsi);
                    _Toastr.success("Link berhasil disalin");
                }}
            >
                Copy
            </Button>

            <Button
                size="small"
                icon={<WhatsAppOutlined />}
                style={{ marginLeft: 10 }}
                onClick={() => {
                    const pesan = `Halo, silakan join konsultasi melalui link berikut:\n${urljitsi}`;
                    const waUrl = `https://wa.me/?text=${encodeURIComponent(pesan)}`;
                    window.open(waUrl, "_blank");
                }}
            >
                Share WA
            </Button>

        </p>
    )  

}

export default RiwayatKonselingExpand
